import React from "react"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { why_choose_cars_image } from '../../../all_constant';



//for redux and saga
import { connect } from 'react-redux';
import { getWhychooseCars } from '../../../redux/actions'

const WhyChoose = (props) => {
  const { getWhyChooseCarAction, getWhyChooseCarsList, loading, error, messages } = props
  // const [whyChooseCarData, setwhyChooseCarData] = useState([])

  console.log("check---", getWhyChooseCarsList, loading, error, messages)

  React.useEffect(() => {
    // alert('calld')
    fetchData()
  }, [])

  const fetchData = () => {
    // alert("hello")
    getWhyChooseCarAction(1)
  }

  
  const Main_title_detail = getWhyChooseCarsList[getWhyChooseCarsList.length - 1];
  
  return (
    <>
      {getWhyChooseCarsList.length > 0
        ? <section className="why-choose-wrap pt-100 pb-70">

          <Container>
          
            <Row>
              <Col md={12}>
                <h2 className="main-title">{Main_title_detail.MainTitle}</h2>
                <p className="sub-title">{Main_title_detail.SubTitle}</p>
              </Col>
            </Row>
            
            <Row className="pt-30">
              {getWhyChooseCarsList && getWhyChooseCarsList.slice(0, getWhyChooseCarsList.length - 1).map((item) => (
                <Col md={6} lg={3} className="pb-2">
                  <div className="why-choose-box">
                    <span>
                      <img src={`${why_choose_cars_image}/${item.Icon}`} alt={item.Title} />
                    </span>
                    <h2>{item.Title}</h2>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>

        </section>
        :
        <Container>

        </Container>
      }

    </>
  );
}

//   export default WhyChoose;

//   whychooseskycar
const mapStateToProps = ({ whychooseskycar }) => {
  // console.log('======', howitwork);
  const { loading, error, messages, getWhyChooseCarsList } = whychooseskycar;
  return { loading, error, messages, getWhyChooseCarsList };
};

export default connect(mapStateToProps, {
  getWhyChooseCarAction: getWhychooseCars,
})(WhyChoose);
